/* eslint-disable camelcase */
import axios from 'axios';
import { useFormik } from 'formik';
import { get } from 'lodash';
import PropTypes from 'prop-types';
import React, { useEffect, useState } from 'react';
import { ButtonGroup, Col, Form, Row } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';
import { withRouter } from 'react-router-dom';
import SlidingPane from "react-sliding-pane";
import * as Yup from 'yup';
import Button from '../../../../shared/components/Button';
import Select from '../../../../shared/components/Select';
import useBreakpoint from '../../../../shared/hooks/useBreakpoint';

const validationSchema = Yup.object().shape({
  reason: Yup.string().required()
});

const HeaderTitle = ({ breakpoint, children, ...params }) =>
  breakpoint === 'xs' ?
    <h4 {...params}>{children}</h4> :
    <h3 {...params}>{children}</h3>;

HeaderTitle.propTypes = {
  breakpoint: PropTypes.string.isRequired,
  children: PropTypes.any.isRequired,
};

const MemoHeaderTitle = React.memo(HeaderTitle);

/**
 *
 * @param {{
 * open: boolean
 * onRequestClose: func
 * }} params
 * @returns
 */
const DeclineSidePane = ({
  history,
  open,
  onRequestClose,
  onAfterClose
}) => {
  const { t } = useTranslation();
  const offer = useSelector(store => get(store, 'offer.offer'));


  const breakpoint = useBreakpoint();

  const [state, setState] = useState({
    reasons: [],
    loading: false
  });

  const formik = useFormik({
    initialValues: {
      reason: null,
    },
    validationSchema,
    onSubmit: values => {
      setState({
        ...state,
        loading: true
      });
      axios.post(`/api/v1/influencers/offers/${offer.id}/user_offers/decline`, {
        offer_declining_reason: values.reason
      }).then(() => {
        setState({
          ...state,
          loading: false
        });
        onRequestClose(false);
        history.push('/');
      });
    }
  });

  useEffect(() => {
    setState({
      ...state,
      loading: true
    });
    axios.get('/api/v1/influencers/user_offers/declined_reasons').then(({ data }) => {
      setState({
        ...state,
        reasons: data.user_offer_declined_reasons,
        loading: false
      });
    });
  }, []);

  return (
    <SlidingPane
      overlayClassName="slide-over"
      isOpen={open}
      closeIcon={null}
      width="375"
      shouldCloseOnEsc
      onRequestClose={() => onRequestClose(false)}
      onAfterClose={onAfterClose}
      hideHeader
      from={document.body.dir === 'ltr' ? 'right' : 'left'}
    >
      <Form onSubmit={formik.handleSubmit}>
        <MemoHeaderTitle breakpoint={breakpoint} className='mb-3' >
          {t('influencers.pages.campaign.decline_side_pane.title')}
        </MemoHeaderTitle>

        <Form.Group>
          <Form.Label>
            {t('influencers.pages.campaign.decline_side_pane.reason')}
          </Form.Label>
          <Select
            className="mb-2"
            placeholder={t('influencers.pages.campaign.decline_side_pane.reason')}
            name="reason"
            defaultValue={formik.values.reason}
            error={get(formik, 'touched.reason') && get(formik, 'errors.reason')}
            onChange={formik.handleChange}
            disabled={state.loading}
            options={state.reasons.map(reason => ({
              label: t(`influencers.pages.campaign.decline_side_pane.${reason}`),
              value: reason
            }))
            }
          />
        </Form.Group>

        <hr className='my-6' />

        <Row className='justify-content-end'>
          <Col className="col-auto">
            <ButtonGroup className="non-adaptable">
              <Button
                variant="secondary"
                type="button"
                onClick={() => onRequestClose(false)}
                disabled={state.loading}>
                {t('influencers.common.cancel')}
              </Button>
              <Button
                variant="primary"
                type="submit"
                disabled={state.loading || !formik.values.reason}>
                {t('influencers.common.decline')}
              </Button>
            </ButtonGroup>
          </Col>
        </Row>

      </Form>
    </SlidingPane>
  );
};

DeclineSidePane.propTypes = {
  history: PropTypes.any,
  open: PropTypes.bool,
  onRequestClose: PropTypes.func.isRequired,
  onAfterClose: PropTypes.func
};

DeclineSidePane.defaultProps = {
  history: null,
  open: false,
  onAfterClose: () => { }
};

export default withRouter(DeclineSidePane);
